import Router, { Route } from "preact-router";
import { useEffect } from "preact/hooks";
import { Landing } from "./screens/Landing";
import { CreateMarket } from "./screens/CreateMarket";
import { JoinMarket } from "./screens/JoinMarket";
import { Lobby } from "./screens/Lobby";
import { Market } from "./screens/Market";
import { ToastContainer } from "./components/Toast";
import { useStore } from "./store";

export function App() {
  const { theme, toasts, dismissToast } = useStore();

  // Apply theme on initial load and when theme changes
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <div class="app">
      <Router>
        <Route path="/" component={Landing} />
        <Route path="/create" component={CreateMarket} />
        <Route path="/join" component={JoinMarket} />
        <Route path="/join/:inviteCode" component={JoinMarket} />
        <Route path="/lobby/:marketId" component={Lobby} />
        <Route path="/market/:marketId" component={Market} />
      </Router>
      <ToastContainer toasts={toasts} onDismiss={dismissToast} />
    </div>
  );
}
